/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data does a bubble chart need?`)
};

const es_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué datos necesita un gráfico de burbujas?`)
};

const de_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Daten benötigt ein Blasendiagramm?`)
};

const nl_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke data heeft een bellendiagram nodig?`)
};

const fr_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles données un graphique à bulles nécessite-t-il ?`)
};

const it_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che dati servono per un grafico a bolle?`)
};

const pt_br2_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados um gráfico de bolhas precisa?`)
};

const pt_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados precisa um gráfico de bolhas?`)
};

const ja_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バブルチャートにはどのようなデータが必要ですか？`)
};

const zh_bubble_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`气泡图需要什么数据？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_faq_q1", locale)
	if (locale === "en") return en_bubble_faq_q1(inputs)
	if (locale === "es") return es_bubble_faq_q1(inputs)
	if (locale === "de") return de_bubble_faq_q1(inputs)
	if (locale === "nl") return nl_bubble_faq_q1(inputs)
	if (locale === "fr") return fr_bubble_faq_q1(inputs)
	if (locale === "it") return it_bubble_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_faq_q1(inputs)
	if (locale === "pt") return pt_bubble_faq_q1(inputs)
	if (locale === "ja") return ja_bubble_faq_q1(inputs)
	return zh_bubble_faq_q1(inputs)
};